import { put, call } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';

import { accountsReceivableAPI } from 'services/apiRest';
import AccountsReceivableActions from '../ducks/accountsReceivable';

export function* getAccountsReceivable() {
  try {
    const accounts = yield call(accountsReceivableAPI.listar);
    yield put(AccountsReceivableActions.getAccountsReceivableSuccess(accounts));
  } catch (err) {
    console.error('Erro ao buscar contas a receber:', err);
    yield put(AccountsReceivableActions.getAccountsReceivableFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao buscar contas a receber',
      })
    );
  }
}

export function* addAccountReceivable({ account, closeModal }) {
  try {
    const accountCriada = yield call(accountsReceivableAPI.criar, account);
    yield put(AccountsReceivableActions.addAccountReceivableSuccess(accountCriada));
    
    if (closeModal) closeModal();
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Conta a Receber',
        message: 'Conta criada com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao criar conta a receber:', err);
    yield put(AccountsReceivableActions.addAccountReceivableFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao criar conta a receber',
      })
    );
  }
}

export function* updateAccountReceivable({ account, closeModal }) {
  try {
    const accountAtualizada = yield call(
      accountsReceivableAPI.atualizar,
      account.id,
      account
    );
    yield put(AccountsReceivableActions.updateAccountReceivableSuccess(accountAtualizada));
    
    if (closeModal) closeModal();
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Conta a Receber',
        message: 'Conta atualizada com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao atualizar conta a receber:', err);
    yield put(AccountsReceivableActions.updateAccountReceivableFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao atualizar conta a receber',
      })
    );
  }
}

export function* removeAccountReceivable({ id }) {
  try {
    yield call(accountsReceivableAPI.deletar, id);
    yield put(AccountsReceivableActions.removeAccountReceivableSuccess(id));
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Conta a Receber',
        message: 'Conta excluída com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao excluir conta a receber:', err);
    yield put(AccountsReceivableActions.removeAccountReceivableFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao excluir conta a receber',
      })
    );
  }
}

